import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ResultDetailReducer, ResultDetails } from "../../modal/results-details";
import { getOneResultDetails } from "./result-details.service";
import { APIStatus } from "../../constants";

const initialState: ResultDetailReducer = {
	name: sessionStorage.getItem("HeaderName") || "",
	getOneResultDetailsCompleted: null,
	getOneResultDetailsResponse: {} as ResultDetails,
};

const ResultDetailSlice = createSlice({
	name: "resultDetails",
	initialState,
	reducers: {
		clearGetOneResultDetail(state) {
			state.getOneResultDetailsCompleted = null;
		},
		resetHeaderName(state, action: PayloadAction<string>) {
			console.log(action.payload);
			state.name = action.payload;
			sessionStorage.setItem("HeaderName", action.payload);
		},
	},
	extraReducers(builder) {
		builder.addCase(getOneResultDetails.fulfilled, (state, action) => {
			state.getOneResultDetailsCompleted = APIStatus.FULFILLED;
			state.getOneResultDetailsResponse = action.payload.data;
		});
		builder.addCase(getOneResultDetails.rejected, (state) => {
			state.getOneResultDetailsCompleted = APIStatus.REJECTED;
		});
	},
});

export const { resetHeaderName, clearGetOneResultDetail } = ResultDetailSlice.actions;

export default ResultDetailSlice.reducer;
